module.exports = __webpack_public_path__ + "static/media/partner-logo5.bd6cd833.png";